import GenericErrorPage from "./GenericErrorPage";
import InternalErrorPage from "./InternalErrorPage";
import NotFoundErrorPage from "./NotFoundErrorPage";
import PermissionErrorPage from "./PermissionErrorPage";

export const getErrorPageFromStatus = (status) => {
  switch (status) {
    case 403:
      return PermissionErrorPage;
    case 404:
      return NotFoundErrorPage;
    case 500:
      return InternalErrorPage;
    default:
      return GenericErrorPage;
  }
};
